export default {
  key: function () {
    const randKey = [...Array(10)].map((i) => {
      return Math.floor((Math.random() * 36)).toString(36)
    }).join('')
    return randKey
  },
  dig: function (ob, path, defaultValue) {
    const def = typeof defaultValue !== 'undefined' ? defaultValue : false
    if (!ob || typeof ob === 'undefined') {
      return def
    }
    const part = path.shift()
    if (path.length > 0) {
      if (typeof ob[part] !== 'undefined') {
        return this.dig(ob[part], path, def)
      } else {
        return def
      }
    } else if (typeof ob[part] !== 'undefined') {
      return ob[part]
    } else {
      return def
    }
  },
  getPropertyByPath: function (obj, path, defaultValue) {
    return this.dig(obj, path.split('.'), defaultValue)
  },
  setPropertyByPath: function (ob, path, value) {
    const parts = path.split('.')
    const part = parts.shift()
    if (parts.length > 0) {
      if (typeof ob[part] !== 'undefined') {
        return this.setPropertyByPath(ob[part], parts.join('.'), value)
      } else {
        return false
      }
    } else if (typeof ob[part] !== 'undefined') {
      ob[part] = value
    } else {
      ob[part] = value
      return false
    }
  },
  basename: function (value) {
    return value.match(/.+\/(.+)$/)[1]
  },
  truncate: function (value, options) {
    const opts = Object.assign({ length: 10, preserveEnds: false }, options)
    if (value.length <= opts.length) {
      return value
    }
    if (!opts.preserveEnds) {
      return value.substr(0, length)
    }
    const cap = Math.floor(opts.length / 2)
    const start = value.substr(0, cap)
    const end = value.substr(-cap)

    return `${start}...${end}`
  },
  getIndexOfObject: function (arr, prop, value) {
    let idx = 0
    let found = false
    // eslint-disable-next-line no-unused-vars
    for (const ob of arr) {
      if (ob[prop] === value) {
        found = true
        break
      }
      idx++
    }
    return found && idx
  },
  filterObjectArray: function (arr, prop, value) {
    return arr.filter(item => {
      return item[prop] === value
    })
  },
  any: function (array) {
    return array.length > 0
  },
  editorToHTML (data) {
    if (typeof data === 'string') {
      return data
    }
    let html = ''
    // eslint-disable-next-line no-unused-vars
    for (const block of data.blocks) {
      const tags = {
        header: 'h2',
        paragraph: 'p'
      }
      const tag = tags[block.type] ? tags[block.type] : 'p'
      html += `<${tag}>${block.data.text}</${tag}>`
    }
    return html
  }
}
